import React from "react"

import { DeliveryDialog, DeliveryDialogProps } from "@cirrus-delivery/v2/features/Dialog/shared/DeliveryDialog"

import { IDialogProps } from "../types/IDialogProps"

export const InfoDialog = ({ content, ...props }: IProps) => {

  return <DeliveryDialog {...props}>
    <DeliveryDialog.ReportIcon />

    <DeliveryDialog.Content>
      {content}
    </DeliveryDialog.Content>
  </DeliveryDialog>
}

type IProps  = IDialogProps & DeliveryDialogProps
